import { render, staticRenderFns } from "./ObjectiveEditorLegacy.vue?vue&type=template&id=8a6beb92&scoped=true&"
import script from "./ObjectiveEditorLegacy.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEditorLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveEditorLegacy.vue?vue&type=style&index=0&id=8a6beb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6beb92",
  null
  
)

export default component.exports